function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M31.5 19.015v-3h8.171a1.5 1.5 0 0 1 1.25.67l3.893 5.862a1.5 1.5 0 0 1 .25.83v9.144a1.5 1.5 0 0 1-1.5 1.5h-4.471v-3h2.972V23.83l-3.198-4.815H31.5zm-17.929 19.5a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm21 3a6 6 0 1 1 0-12 6 6 0 0 1 0 12zm0-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-24-16.5a1.5 1.5 0 0 1 0-3h9a1.5 1.5 0 0 1 0 3h-9zm19.454 12.022v3H18.092v-3h11.933zM9.057 31.01v3H7.5a4.5 4.5 0 0 1-4.5-4.5V14.5A4.5 4.5 0 0 1 7.5 10h20.968a4.5 4.5 0 0 1 4.5 4.5v14.613h-3V14.5a1.5 1.5 0 0 0-1.5-1.5H7.5A1.5 1.5 0 0 0 6 14.5v15.01a1.5 1.5 0 0 0 1.5 1.5h1.557z"
});

var SvgDeliveryActive = function SvgDeliveryActive(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgDeliveryActive;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/delivery-active.svg
// module id = 136
// module chunks = 0 1